import { motion, AnimatePresence } from "framer-motion/dist/framer-motion";
import { MDBBtn } from "mdb-react-ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import { useEffect } from "react";

const backdrop = {
  visible: { opacity: 1, transition: { duration: 0.3 } },
  hidden: { opacity: 0, transition: { duration: 0.2 } },
};

const modal = {
  hidden: {
    x: "-100vw",
    opacity: 1,
  },
  visible: {
    x: "0px",
    opacity: 1,
    transition: { type: "linear", duration: 0.6 },
  },
};

const Modal = (props) => {
  // Prevent Background scroll when scroll on backdrop
  useEffect(() => {
    if (props.showModal) {
      document.querySelector("body").style.cssText +=
        "touch-action: none;-ms-touch-action: none;overflow:hidden";
    } else {
      document.querySelector("body").style.removeProperty("touch-action");
      document.querySelector("body").style.removeProperty("-ms-touch-action");
      document.querySelector("body").style.overflow = "auto";
    }
  }, [props.showModal]);

  return (
    <AnimatePresence exitBeforeEnter>
      {props.showModal && (
        <motion.div
          id="modal"
          className="backdrop"
          variants={backdrop}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={(e) => {
            e.stopPropagation();
            props.setShowModal(false);
          }}
          onScroll={(e) => e.stopPropagation()}
        >
          <div className="container">
            <motion.div
              className="innerModal"
              variants={modal}
              onClick={(e) => e.stopPropagation()}
              onScroll={(e) => e.stopPropagation()}
            >
              <div className="d-flex justify-content-end mb-3">
                <MDBBtn
                  outline
                  className="d-flex justify-content-center align-items-center modal-close"
                  onClick={() => {
                    props.setShowModal(false);
                  }}
                >
                  <FontAwesomeIcon
                    icon={faTimes}
                    size="2x"
                    style={{ maxHeight: "15px" }}
                  />
                </MDBBtn>
              </div>
              {props.children}
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
